import React from 'react'

export const SettingLanguages = () => {
  return (
    <div>SettingLanguages</div>
  )
}
